import { request } from "../../utils/config"

export const CREATE_PRODUCT_UNIT = async (data) => {
  const response = await request({
    url: `productUnits`,
    method: "POST",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const UPDATE_PRODUCT_UNIT = async (data) => {
  const response = await request({
    url: `productUnits`,
    method: "PUT",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}

export const DELETE_PRODUCT_UNIT = async (data) => {
  const response = await request({
    url: `productUnits/BulkDelete`,
    method: "DELETE",
    data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
